<!-- 登录模态框 -->
<template>
  <sweet-modal ref="loginModal" class="modal-login">
    <div v-show="!qrcodeLogin" class="login-pc" v-if="step1">
      <div class="login-title">登录／注册</div>
      <div class="tel-contain">
        <div class="error-msg1" v-show="isShowMsg">
          <span>{{errorMsg}}</span>
        </div>
        <input class="tel"
          v-model="tel1"
          maxlength="11"
          type="text"
          @change="telChangeAction"
          @focus="telFocusAction"
          name=""
          placeholder="输入手机号码"
          @keyup.enter="telAction"
          autofocus="true"/>
      </div>
      <div class="next-step" @click="telAction">继续</div>
    </div>
    <div v-show="!qrcodeLogin" class="login-pc" v-else-if="step2">
      <div class="login-title">登录</div>
      <div class="tel-contain1">
        <div class="error-msg" v-show="isShowMsg1">
          <span v-html="errorMsg1"></span>
        </div>
        <input class="tel"
          v-model="tel2"
          type="text"
          readonly/>
      </div>
      <div class="psw-contain">
        <input class="psw"
          type="password"
          v-model="psw1"
          @focus="telCaptchaFocusAction"
          placeholder="您已注册，请输入密码"
          @keyup.enter="loginAction"
          autofocus="true"/>
      </div>
      <div class="forget-psw">
        <a href="dcf/minisite.html#/forget">
          忘记密码
        </a>
      </div>
      <div class="captcha-container" v-if="captchaContainer">
        <input @focus="telCaptchaFocusAction" placeholder="输入验证码"  v-model="captchaCode" class="captcha-code">
        <img :src="catpchaImg" class="captcha-img">
      </div>
      <div class="login-next-step" @click="loginAction">继续</div>
      <div class="return-back" @click="returnBackAction"></div>
    </div>
    <!-- 预认证 start -->
    <div v-show="!qrcodeLogin" class="login-pc" v-else>
      <div class="login-title">注册</div>
      <div class="tel-contain1">
        <div class="error-msg" v-show="isShowMsg2">
          <span v-html="errorMsg2"></span>
        </div>
        <input class="tel" v-model="tel2" type="text" readonly/>
      </div>
      <div class="psw-contain">
        <input class="psw" type="password" v-model="psw1" @focus="telCaptchaFocusAction" placeholder="设置密码(6-20位，数字及字母的组合)" autofocus="true"/>
      </div>
      <div class="captcha-container">
        <input @focus="telCaptchaFocusAction" placeholder="输入验证码"  v-model="perCaptchaCode" class="captcha-code">
        <button class="btn-captcha" @click="getPerVerifyCaptcha" :disabled="!isShowCaptcha">
          <span v-show="isShowCaptcha">获取验证码</span>
          <span v-show="!isShowCaptcha">{{count}}s</span>
        </button>
      </div>
      <div class="login-next-step" @click="loginAction">继续</div>
      <div class="return-back" @click="returnBackAction"></div>
    </div>
    <!-- 预认证 end -->
    <div v-show="qrcodeLogin" class="login-qrcode" id="login-qrcode">
    </div>
    <div :class="{'login_icon': true, 'qrcode': qrcodeLogin}" @click="toggleLogin()"></div>
  </sweet-modal>
</template>

<script>
import loginResolve from '@/assets/js/LoginResolve'
import { win, getQueryString, isCellphone } from '@/assets/js/CommonUtils'
import WxLogin from './../js/wxLogin'
import cookieUtils from '@/assets/js/CookieUtils'
const MOCK = ''
// 获取验证码倒计时
const TIME_COUNT = 60
// 登录状态
const LOGIN_STATUS = {
  WRONG_NAME_OR_PASSWORD: 91042201, // 用户名/密码错误
  WRONG_CAPTCHA: 91042002, // 验证码错误
  LOCKED: 91042203, // 账户锁定
  BLOCKCHAIN: 91042106
}

// 用户注册状态
const REGISTER_STATUS = {
  UNREGISTER: 1,
  REGISTERED: 2,
  PRE_VERIFY: 3
}

// 更新消息
function updateMsg (loginStatus, retryCount, vm) {
  const messages = []

  if (loginStatus === LOGIN_STATUS.WRONG_NAME_OR_PASSWORD) {
    messages.push('用户名/手机号或密码错误')
    if (retryCount > 0 && retryCount < 4) {
      messages.push('登录次数剩余' + retryCount + '次')
    }
  } else if (loginStatus === LOGIN_STATUS.LOCKED) {
    messages.push('账号被锁定, <a href="/public/unlock.jsp?ftype=user">解锁</a>')
  } else if (loginStatus === LOGIN_STATUS.WRONG_CAPTCHA) {
    messages.push('验证码错误')
  } else if (loginStatus === LOGIN_STATUS.BLOCKCHAIN) {
    messages.push('对不起，服务正在建设中，为不影响您的使用，请下载群星APP')
  } else {
    messages.push('服务暂不可用')
  }

  if (messages.length > 0) {
    vm.errorMsg1 = messages.join('、')
    vm.errorMsg = messages.join('、')
  } else {
    vm.errorMsg1 = ''
    vm.errorMsg = ''
  }
}
// 获取主域名
function getMainDomain () {
  let mainDomain = null
  const hostName = win.getLocation().hostname
  const domainSplit = hostName.split('.')
  if (domainSplit.length >= 3) {
    var sectionList = []
    var skipStep = domainSplit.length - 2
    for (var i = skipStep; i < domainSplit.length; i++) {
      sectionList.push(domainSplit[i])
    }
    mainDomain = sectionList.join('.')
  } else {
    mainDomain = 'localhost'
  }
  return mainDomain
}

export default {
  extends: loginResolve,
  data () {
    return {
      registerUrl: '/minisites/registration/',
      isLogining: false,
      qrcodeLogin: false,
      step1: true,
      isShowMsg: false,
      tel1: '',
      errorMsg: '',
      isShowMsg1: false,
      errorMsg1: '',
      psw1: '',
      catpchaImg: '',
      captchaContainer: false,
      captchaCode: '',
      perCaptchaCode: '',
      step2: false,
      isShowMsg2: false,
      errorMsg2: '',
      count: '',
      timer: null,
      isShowCaptcha: true
    }
  },
  mounted () {
    var vm = this
    let loginResult = getQueryString('result')
    if (loginResult) {
      vm.open()
      switch (Number(loginResult)) {
        case 8:
          loginResult = 91042106
          break
        default:
          loginResult = 0
          break
      }
      vm.isShowMsg = true
      updateMsg(loginResult, 10, this)
    }
  },
  methods: {
    getPerVerifyCaptcha () {
      const vm = this
      vm.ajax({
        type: 'GET',
        url: '/api/common/v1/captcha/send/message',
        data: {
          cellPhone: vm.tel2
        },
        success: function (data) {
          vm.getCount()
        }
      })
    },
    getCount () {
      if (!this.timer) {
        this.count = TIME_COUNT
        this.isShowCaptcha = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.isShowCaptcha = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    telCaptchaFocusAction () {
      this.isShowMsg1 = false
      this.isShowMsg2 = false
    },
    getCaptcha (vm) {
      vm.ajax({
        type: 'GET',
        url: '/api/common/v1/captcha/generate/graphical',
        data: {
          capthcaId: vm.tel2
        },
        success: function (data) {
          vm.catpchaImg = 'data:image/jpeg;base64, ' + data.bodyText
        }
      })
    },
    returnBackAction () {
      this.isShowMsg1 = false
      this.psw1 = ''
      this.step1 = true
      this.isShowMsg2 = false
    },
    telChangeAction () {
      var vm = this
      if (isCellphone(vm.tel1)) {
        vm.isShowMsg = false
      } else {
        vm.errorMsg = '手机号码格式不正确'
        vm.isShowMsg = true
      }
    },
    telFocusAction () {
      if (this.tel1) {
        this.isShowMsg = false
      }
    },
    getTelState (tel) {
      const vm = this
      vm.ajax({
        url: MOCK + '/api/user/v3/public/registerStatus',
        type: 'POST',
        data: JSON.stringify({
          cellphone: tel
        }),
        success (res) {
          if (res.data === REGISTER_STATUS.REGISTERED) {
            // vm.step1 = !vm.step1
            vm.step1 = false
            vm.step2 = true
            vm.step3 = false
            vm.tel2 = vm.tel1
          } else if (res.data === REGISTER_STATUS.UNREGISTER) {
            const customizedLogo = getQueryString('c')
            if (customizedLogo) {
              window.open('/dcf/minisite.html?cellphone=' + vm.tel1 + '&c=' + customizedLogo)
            } else {
              window.location.href = '/dcf/minisite.html?cellphone=' + vm.tel1
            }
          } else {
            vm.step1 = false
            vm.step2 = false
            vm.step3 = true
            vm.tel2 = vm.tel1
          }
        },
        error (res) {
          vm.isShowMsg = true
          if (res && res.data && res.data.message) {
            vm.errorMsg = res.data.message
          } else {
            vm.errorMsg = '用户是否注册未知异常'
          }
        }
      })
    },
    telAction () {
      var vm = this
      if (isCellphone(vm.tel1)) {
        vm.isShowMsg = false
        vm.getTelState(vm.tel1)
      } else {
        vm.errorMsg = '手机号码格式不正确'
        vm.isShowMsg = true
      }
    },
    login (tel, psw, captcha) {
      var param = {}
      param.cellphone = tel
      param.password = psw
      const vm = this
      // console.log(captcha)
      if (captcha) {
        param.captcha = captcha
      }
      vm.ajax({
        url: MOCK + '/api/user/v2/public/login',
        type: 'POST',
        data: JSON.stringify(param),
        success (res) {
          const content = res.data
          const mainDomain = getMainDomain()
          cookieUtils.set('tk', content.token, {
            domain: mainDomain
          })
          vm.loginResolve(content, false)
        },
        error (res) {
          vm.isShowMsg1 = true
          if (res && res.data && res.data.code && res.data.message) {
            if (res.data.code === 91042201 || res.data.code === 91042203 || res.data.code === 91042002) {
              if (res.data.extras.tryCount) {
                vm.captchaContainer = false
                let retryCount = 10 - res.data.extras.tryCount
                if (retryCount <= 7) {
                  vm.getCaptcha(vm)
                  vm.captchaContainer = true
                }
                updateMsg(res.data.code, retryCount, vm)
              } else {
                updateMsg(res.data.code, 10, vm)
              }
            } else {
              vm.errorMsg1 = res.data.message
            }
          } else {
            vm.errorMsg1 = '登录未知异常'
          }
        }
      })
    },
    resetPassword () {
      var vm = this
      vm.ajax({
        type: 'POST',
        url: '/api/user/v2/public/resetPassword',
        data: JSON.stringify({
          cellphone: vm.tel2,
          password: vm.psw1,
          captcha: vm.perCaptchaCode
        }),
        success: function (data) {
          vm.login(vm.tel2, vm.psw1, vm.captchaCode)
        },
        error (res) {
          vm.isShowMsg2 = true
          if (res && res.data && res.data.message) {
            vm.errorMsg2 = res.data.message
          } else {
            vm.errorMsg2 = '用户是否注册未知异常'
          }
        }
      })
    },
    loginAction () {
      // 如果是预认证先修改密码再登入
      if (!this.step1 && !this.step2) {
        this.resetPassword()
      } else {
        this.login(this.tel2, this.psw1, this.captchaCode)
      }
    },
    open (param) {
      if (this.$route.path === '/role/fund') {
        this.registerUrl = '/minisites/registration_org/'
      } else {
        this.registerUrl = '/minisites/registration/'
      }
      this.message = ''
      this.qrcodeLogin = false
      this.$refs.loginModal.open()
      this.getQrcode()
    },
    toggleLogin () {
      this.qrcodeLogin = !this.qrcodeLogin
    },
    getQrcode () {
      const vm = this
      // 微信登录获取状态码
      vm.ajax({
        url: '/api/user/v1/public/getRandomState',
        type: 'GET',
        success: function (res) {
          let wxOptions = {
            id: 'login-qrcode',
            scope: 'snsapi_login',
            state: res.bodyText,
            style: '',
            href: 'https://www.iqunxing.com/css/wechat-login-qr.css?v=20170630'
          }
          if (location.host !== 'www.iqunxing.com') { // 非产线
            wxOptions.redirect_uri = encodeURIComponent('http://test1.iqunxing.com/open/wechat/webLogin/callback')
            wxOptions.appid = 'wx507dd1d351e50ef6'
          } else {
            wxOptions.redirect_uri = encodeURIComponent('https://home.iqunxing.com/open/wechat/webLogin/callback')
            wxOptions.appid = 'wxac2f44444a1c36ce'
          }
          // 步骤2：在需要使用微信登录的地方实例以下JS对象
          let initWechatInterval = setInterval(function () {
            const loginContainer = document.getElementById('login-qrcode')
            if (WxLogin && loginContainer) {
              /* eslint-disable no-new */
              new WxLogin(wxOptions)
              clearInterval(initWechatInterval)
              initWechatInterval = null
            }
          }, 500)
        },
        error: function (res) {
          console.log(res)
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css//utils";
@import "../css/theme-config";
.login-pc{
  height: 276px;
  position: relative;
  .return-back{
    position: absolute;
    height: 30px;
    width: 30px;
    left: 0;
    top: 0;
    cursor: pointer;
    &:before{
      @include icon();
      content: $ICO-BACK;
      color: #405D7B;
      top: -30px;
      left: 0px;
    }
  }
}
.login-title{
  height: 22px;
  margin-top: 20px;
  width: 100%;
  font-size: 22px;
  line-height: 22px;
  text-align: center;
  color: #4E75F8;
}
.tel-contain{
  height: 42px;
  width: 100%;
  margin-top: 58px;
  border: #E6E6E6 1px solid;
  position: relative;
  .tel{
    height: 40px;
    width: 96%;
    margin-left: 2%;
    border: none;
  }
  .error-msg{
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #fff;
    border-radius: 20px;
    position: absolute;
    top: -38px;
    width: 100%;
    text-align: left;
    background-color: #4e75f8;
    span{
      margin-left: 10px;
    }
  }
  .error-msg1{
    // height: 28px;
    line-height: 16px;
    // padding: 5px 10px;
    padding-left: 4.5%;
    padding-right: 4.5%;
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 12px;
    color: #fff;
    border-radius: 20px;
    position: absolute;
    top: -48px;
    width: 91%;
    text-align: left;
    background-color: #4e75f8;
    span{
      // padding: 5px 10px;
      // margin-left: 10px;
    }
  }
}
.captcha-container{
  height: 42px;
  margin-top: 8px;
  .captcha-code{
    display: inline-block;
    width: 50%;
    height: 36px;
    border: #E6E6E6 1px solid;
    float: left;
    padding-left: 10px;
  }
  .captcha-img{
    display: inline-block;
    width: 40%;
    height: 40px;
    background-color: #0f0;
    float: right;
  }
  .btn-captcha{
    // display: inline-block;
    background-color: #2c80fe;
    color: #fff;
    text-align: center;
    width: 110px;
    height: 100%;
    float: right;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    // margin-left: 4px;
    &:disabled{
      background-color: #bfbfbf;
      cursor: not-allowed;
    }
  }
}
.tel-contain1{
  height: 42px;
  width: 100%;
  margin-top: 38px;
  border: #E6E6E6 1px solid;
  position: relative;
  .tel{
    height: 40px;
    width: 96%;
    margin-left: 2%;
    border: none;
  }
  .error-msg{
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #fff;
    border-radius: 20px;
    position: absolute;
    top: -35px;
    width: 100%;
    text-align: left;
    background-color: #4e75f8;
    span{
      margin-left: 10px;
    }
  }
}
.psw-contain{
  height: 42px;
  width: 100%;
  margin-top: 10px;
  border: #E6E6E6 1px solid;
  .psw{
    height: 40px;
    width: 96%;
    margin-left: 2%;
    border: none;
  }
}
.forget-psw{
    height: 12px;
    line-height: 12px;
    text-align: right;
    font-size: 12px;
    margin-top: 10px;
    a{
      color: #2C80FE;
    }
  }
.next-step{
  height: 38px;
  width: 40%;
  background-color: #4E75F8;
  margin-left: 30%;
  margin-top: 50px;
  margin-bottom: 30px;
  border-radius: 100px;
  line-height: 38px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.login-next-step{
  height: 38px;
  width: 40%;
  background-color: #4E75F8;
  margin-left: 30%;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 100px;
  line-height: 38px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
.login-qrcode{
  margin-left: -0.2rem;
  margin-bottom: -1.1rem;
  @include mediaQuery() {
    padding-bottom: 0.86rem;
    padding-top: 0.85rem;
  }
}
.login_icon{
  width: 0.5rem;
  height: 0.5rem;
  position: absolute;
  right: 0.04rem;
  bottom: 0.04rem;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.25, 0.5, 0.5, 0.9) 0s;
  background-repeat: no-repeat;
  background-size: 1rem 1rem;
  background-image: url('/imgs/portal/login/login_icon.jpg');
  @include media2x(url('/imgs/portal/login/login_icon@2x.jpg'));
  background-position: 0rem -0.5rem;
  @include mediaQuery() {
    height: 1rem;
    width: 1rem;
    background-size: 2rem 2rem;
    background-position: 0 -1rem;
    -webkit-tap-highlight-color: transparent;
  }

  &.qrcode{
   background-position: -0.5rem 0rem;
   @include mediaQuery() {
    background-position: -1rem 0;
   }
  }
}
</style>

<!-- effective to children, aim to override children scoped CSS -->
<style lang="scss">
@import "../css/theme-config";
@import "~@/assets/css/utils";

.modal-login {
  // override <sweet-modal> scoped CSS
  background: rgba(0, 0, 0, 0.7) none repeat scroll 0 0;

  .sweet-modal {
    width: 3rem;
    @include mediaQuery() {
      width: 66%;
    }
  }
  .sweet-modal.sweet-alert {
    top: auto;
    bottom: 30%;
    transform: scale(0.9) translate(calc(-50% - 0.32rem), 0);
    @include mediaQuery() {
      position: relative;
      top: 50%;
      bottom: auto;
    }
    
    &.is-visible{
      transform: translate(-50%, 0);
      @include mediaQuery() {
        transform: translate(-50%, -50%)
      }
    }

    .sweet-box-actions{
      top: 0.1rem;
      right: 0.08rem;
      z-index: 100;
      @include mediaQuery() {
        -webkit-tap-highlight-color: transparent;
      }
      .sweet-action-close{
        height: 0.24rem;
        width: 0.24rem;
        @include mediaQuery() {
          height: 0.4rem;
          width: 0.4rem;
        }
        &:hover{
          background: none;
          color: $Color1;
        }
        svg{
          vertical-align: top;
          @include mediaQuery() {
            height: 0.4rem;
            width: 0.4rem;
          }
        }
      }
    }

    .sweet-content {
      padding: 0.2rem;
      overflow: hidden;
      @include mediaQuery() {
        padding: 0.4rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ModalLogin.vue?56a3938a